import React, { useEffect, useState } from "react";

import { Instant } from "@js-joda/core";
import { formatDuration, timeDifference } from "../../../utils/time-utils";

const TimeDiff = ({ time }: { time: Instant }) => {
  const [diffSec, setDiffSec] = useState(timeDifference(time));

  useEffect(() => {
    const interval = setInterval(() => {
      if (time.isAfter(Instant.now())) {
        setDiffSec(difSec => difSec - 1);
      } else {
        setDiffSec(difSec => difSec + 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setDiffSec(timeDifference(time));
  }, [time]);

  return (
    <>
      {time.isAfter(Instant.now()) && "-"}
      {formatDuration(diffSec)}
    </>
  );
};

export default TimeDiff;
